import { useAdminContentSettingsContext } from "@/search/AdminContentSettingsContext/AdminContentSettingsContext";
import getUserProperties from "@/users/getUserProperties";
import useUser from "@/users/useUser";
import { useSearchPageContext } from "../../provider/SearchPageProvider";
import { SEARCH_PARAMS, URL_PARAMS } from "../../NewSearchPageMVP.constants";

export const useContentSettings = () => {
  const {
    handlers: {
      deleteSearchParamValues,
      setSearchParamValue,
      toggleSearchParamValue,
    },
  } = useSearchPageContext();
  const { contentSettingsToggleEnabled } = useAdminContentSettingsContext();

  const { data: user } = useUser();
  const {
    activeEssentialsLicense,
    activeELALicense,
    activeSSLicense,
    activeScienceLicense,
  } = getUserProperties(user, { shouldUseNewUserApi: false });

  const isOnlyActiveEssentialsLicense =
    activeEssentialsLicense &&
    !activeELALicense &&
    !activeSSLicense &&
    !activeScienceLicense;

  const invokeContentSettingsSearchModeChange = () => {
    if (contentSettingsToggleEnabled) {
      /*
        The Content Settings mode was activated, but the change in the mode
      * (prompted by the toggle change) deactivated it...delete the following query params
      */
      deleteSearchParamValues(URL_PARAMS.adminContentSettings);
      deleteSearchParamValues(URL_PARAMS.contentTypes);
      deleteSearchParamValues(URL_PARAMS.gradeGroups);
    } else {
      // the Content Settings mode was deactivated, but the change activated it...insert the following query params
      if (isOnlyActiveEssentialsLicense) {
        setSearchParamValue(
          URL_PARAMS.contentTypes,
          SEARCH_PARAMS.articleHeader,
        );
      } else {
        toggleSearchParamValue(
          URL_PARAMS.contentTypes,
          SEARCH_PARAMS.articleHeader,
        );
        toggleSearchParamValue(
          URL_PARAMS.contentTypes,
          SEARCH_PARAMS.interactiveVideoLink,
        );
      }
      setSearchParamValue(URL_PARAMS.adminContentSettings, "true");
    }
  };

  return { invokeContentSettingsSearchModeChange };
};
